import { render, staticRenderFns } from "./vPreviewLabel.vue?vue&type=template&id=3c7f9eaf&scoped=true"
import script from "./vPreviewLabel.vue?vue&type=script&setup=true&lang=ts"
export * from "./vPreviewLabel.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7f9eaf",
  null
  
)

export default component.exports